import { SHEET_SECTION, STAGE } from './sheet-sections.js';
import { technicalOwner } from './responsibility.js';
export const TECHNICAL_TASKS = [
    { role: 'PATTERN', section: SHEET_SECTION.MATERIAL, stage: STAGE.TRIM_TECHNICAL_DONE, tab: 'trimBom' },
    { role: 'PATTERN', section: SHEET_SECTION.PATTERN, stage: STAGE.BASE_SIZE_DONE, tab: 'size' },
    { role: 'CAD', section: SHEET_SECTION.MATERIAL, stage: STAGE.USAGE_ENTERED, tab: 'cost' },
    { role: 'CAD', section: SHEET_SECTION.PATTERN, stage: STAGE.SIZE_SPEC_DONE, tab: 'deviation' },
];
/** 本款版师收到全部未完成技术任务，兼容字段不形成独立岗位。 */
export function technicalTaskTarget(username, charges, marks) {
    if (!username || technicalOwner(charges) !== username)
        return null;
    const done = (section, stage) => marks.some((m) => m.section === section && m.stage === stage && m.completed);
    const task = TECHNICAL_TASKS.find((t) => !done(t.section, t.stage));
    return task ? { section: task.section, tab: task.tab } : null;
}
//# sourceMappingURL=technical-task.js.map